// custom history object to allow navigation outside react components
export const routerHistory = {
    navigate: null,
    location: null
  };
  